import React, { useEffect } from "react";

function useCustomEvent(eventName, cb) {

  useEffect(() => {
    window.addEventListener(eventName, cb);
    return () => {
      window.removeEventListener(eventName, cb);
    };
  }, []);
  return null;;
}

export default useCustomEvent;
